export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/presentation_design.5df763d.svg";